import Axios from "../../axios-default"

const namespaced = true;

const state = () => ({
  loading: false,
  saving: false,
  syncTime: null,
  syncPeriod: 1000 * 60 * 1,
  itemsPerPage: 20,
  icons: ['mdi-exclamation','mdi-wifi-off','mdi-alert-circle-outline','mdi-information-variant'],
  colors: ['red','orange','orange','blue'],
  currentControllerId: null,
  alerts: []
});

const getters = {
  alerts(state) {
    return state.alerts;
  },
  icons(state) {
    return state.icons;
  },
  list(state) {
    return state.alerts;
  }
};

const mutations = {
  setLoading(state, loading) {
    state.loading = loading
  },
  setSaving(state, saving) {
    state.saving = saving
  },
  setSyncTime(state, syncTime) {
    state.syncTime = syncTime
  },
  create(state, data) {
    state.alerts = data
  },
  append(state, data) {
    state.alerts.push(...data);
  },
  reset(state, controllerId) {
    state.alerts = [];
    state.syncTime = null;
    state.loading = false;
    state.currentControllerId = controllerId;
  }
};

const actions = {  
  async load ({commit, rootGetters, state}, {controllerId, startIndex, forced}) {
    //reset jesli zmiana kontrolera
    if (controllerId != state.currentControllerId) {
      commit('reset', controllerId);
    }
    
    try {
      if (!state.loading && (forced || state.syncTime === null || new Date().getTime() - state.syncTime > state.syncPeriod)) {
        commit('setLoading', true);
        const formData = new URLSearchParams();
        formData.append('controllerId', controllerId);
        formData.append('token', rootGetters.token);
        formData.append('startIndex', startIndex);
        formData.append('itemsPerPage', 20);
        
        const res = await Axios.post('/api/sterownik/alarm/lista?t=' + Date.now(), formData);
        if (typeof res.data !== 'object') {
          res.data = {error:{code:'0'}};
        } else {
          commit('setLoading', false);
          if (startIndex == 1) {
            commit('create', res.data);
          } else {
            commit('append', res.data);
          }
          commit('setSyncTime', new Date().getTime());
        }
        return res.data;
      } else {
        return { skip: true }
      }
    }
    catch (error) {
      return console.log(error);
    }
  },
  
};

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions
}

